
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.707 8.707a1 1 0 000-1.414L8.343.929A1 1 0 006.93 2.343L12.586 8l-5.657 5.657a1 1 0 101.414 1.414l6.364-6.364zM0 9h14V7H0v2z","fill":"#fff"}})])
          )
        }
      }
    